var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('b-row',{staticClass:"justify-content-center"},[_c('b-col',{staticClass:"text-center py-5",attrs:{"md":"8"}},[_c('dashboard-tiles',{attrs:{"items":_vm.nav}})],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }